module.exports = __webpack_public_path__ + "static/media/ATM.1343108f.png";